import { useContext, useEffect } from "react";
import { config } from "../../../config";
import Nav from "./Nav";
import useLocalStorage from "../../../state/global/localStorage";
import APIStatusProvider from "../../../providers/apiStatusProvider";
import APIStatusDisplay from "../content/APIStatusDisplay";
import MessageProvider from "../../../providers/MessageProvider";
import MessageDisplay from "../content/MessageDisplay";
import { AuthContext } from "../../../providers/AuthProvider";

export default function PageBody({ children, className, secondaryNavItems, noChildPadding, title, mobileLayoutHeight, ...rest }) {
	const [darkMode, setDarkMode] = useLocalStorage("darkMode", false);
	//const { isMobileDevice } = useContext(AuthContext);
    
    const darkHandler = (e) => {
        setDarkMode(e);
        if (e) {
            document.body.classList.add("dark");
        } else {
            document.body.classList.remove("dark");
        }
    };

	useEffect(() => {
		if (title) {
			document.title = `${config.app.title} - ${title}`;
		}
	}, [title]);

    return (
		<MessageProvider>
			<APIStatusProvider>
				<APIStatusDisplay className="pt-2.5" svgClassSpinner="fill-light-5" svgClassBackground="fill-light-2" isModal={false} />
				<MessageDisplay className="pt-2.5" onSubmit isModal={false} />
				<div 
					id="appRoot"
					className={`flex flex-col justify-between w-full ${className}`}
					style={{height: mobileLayoutHeight ? `${window.innerHeight}px` : "100vh"}} {...rest}
				>
					<Nav noChildPadding={noChildPadding} secondaryNavItems={secondaryNavItems} darkHandler={darkHandler} darkMode={darkMode} >
						{title &&
							<h1 className="text-light-1 mb-1 -mt-1 sm:-mt-3">{title}</h1>
						}
						{children}
					</Nav>
				</div>
			</APIStatusProvider>
		</MessageProvider>
    )
}